<script>
import { useAlert } from 'dashboard/composables';
import TeamForm from '../TeamForm.vue';
import { useRouter } from 'vue-router';
import PageHeader from '../../SettingsSubPageHeader.vue';

export default {
  components: {
    TeamForm,
    PageHeader,
  },
  setup() {
    return { router: useRouter() };
  },
  data() {
    return {
      isSaving: false,
    };
  },
  methods: {
    async createTeam(data) {
      if (this.isSaving) return;
      this.isSaving = true;
      try {
        const team = await this.$store.dispatch('teams/create', {
          ...data,
        });

        this.router.replace({
          name: 'settings_teams_add_agents',
          params: {
            page: 'new',
            teamId: team.id,
          },
        });
      } catch (error) {
        useAlert(this.$t('TEAMS_SETTINGS.TEAM_FORM.ERROR_MESSAGE'));
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>

<template>
  <div class="h-full w-full p-6 col-span-6 overflow-y-auto">
    <PageHeader
      :header-title="$t('TEAMS_SETTINGS.CREATE_FLOW.CREATE.TITLE')"
      :header-content="$t('TEAMS_SETTINGS.CREATE_FLOW.CREATE.DESC')"
    />
    <div class="flex flex-wrap">
      <TeamForm
        :on-submit="createTeam"
        :submit-in-progress="isSaving"
        :submit-button-text="$t('TEAMS_SETTINGS.FORM.SUBMIT_CREATE')"
      />
    </div>
  </div>
</template>
